/**
 * Iter270.1 / Task 4 — SkipToMainContent
 *
 * WCAG 2.1 AA — Keyboard users need a way to bypass the long header
 * + mega-menu and jump straight to the page's main content. Renders
 * an invisible-by-default anchor that becomes visible on focus.
 *
 * The page's <main> element (or any element with id="qt-main") becomes
 * the target. Most public pages render a <main role="main"> at the
 * top of their layout already.
 */
import React from "react";

export default function SkipToMain() {
  return (
    <a
      href="#qt-main"
      data-testid="skip-to-main"
      className="qt-skip-to-main"
      style={{
        position: "absolute", top: 8, left: 8,
        background: "#67E8F9", color: "#04091A",
        padding: "8px 14px", borderRadius: 8,
        fontSize: 13, fontWeight: 600,
        textDecoration: "none",
        // Invisible until focused. Visible focus state ensures keyboard
        // users see the link; sighted mouse users never notice it.
        transform: "translateY(-200%)",
        opacity: 0,
        transition: "transform 160ms ease, opacity 160ms ease",
        zIndex: 9999,
      }}
      onFocus={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.opacity = "1";
      }}
      onBlur={(e) => {
        e.currentTarget.style.transform = "translateY(-200%)";
        e.currentTarget.style.opacity = "0";
      }}
    >
      Skip to main content
    </a>
  );
}
